import { httpV2 } from "@/api/index";

/**
 * Solicita o resultado do modo de falha nas pás.
 * @param {Number} resultId Id do resultado geral do modo de falha.
 * @returns {promise} Retorna status do diagnóstico.
 */
const GetDiagnostics = function(resultSetId)
{
	return httpV2.get(`/HydroGeneratingUnitDiagnostic/${resultSetId}/BladeDefect`);
};

export default { GetDiagnostics };